var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardViewBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.16732C1.5 1.70708 1.8731 1.33398 2.33333 1.33398H6.5C6.96024 1.33398 7.33333 1.70708 7.33333 2.16732V6.33398C7.33333 6.79422 6.96024 7.16732 6.5 7.16732H2.33333C1.8731 7.16732 1.5 6.79422 1.5 6.33398V2.16732Z",
    stroke: "#000000",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 2.16732C9.83325 1.70708 10.2063 1.33398 10.6666 1.33398H14.8333C15.2935 1.33398 15.6666 1.70708 15.6666 2.16732V6.33398C15.6666 6.79422 15.2935 7.16732 14.8333 7.16732H10.6666C10.2063 7.16732 9.83325 6.79422 9.83325 6.33398V2.16732Z",
    stroke: "#000000",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5013C1.5 10.0411 1.8731 9.66797 2.33333 9.66797H6.5C6.96024 9.66797 7.33333 10.0411 7.33333 10.5013V14.668C7.33333 15.1282 6.96024 15.5013 6.5 15.5013H2.33333C1.8731 15.5013 1.5 15.1282 1.5 14.668V10.5013Z",
    stroke: "#000000",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 10.5013C9.83325 10.0411 10.2063 9.66797 10.6666 9.66797H14.8333C15.2935 9.66797 15.6666 10.0411 15.6666 10.5013V14.668C15.6666 15.1282 15.2935 15.5013 14.8333 15.5013H10.6666C10.2063 15.5013 9.83325 15.1282 9.83325 14.668V10.5013Z",
    stroke: "#000000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardViewBlackIcon);
export default __webpack_public_path__ + "static/media/card-view-black-icon.c154de520c92ef569747dce0e05bdb0a.svg";
export { ForwardRef as ReactComponent };